import { useEffect } from "react"

export const useAutoScrollOnLoad = () => {
    useEffect(() => {
        if(window.scrollY !== 0) {
            window.scrollTo(0, 0);
        }
    }, []);
}